import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHead, Btn, Card, Field, Select, Toggle } from "@/admin/ui";
import { toast } from "sonner";

const empty = () => ({ code: "", type: "percent", value: 10, active: true, early_access: false, min_spend: null, usage_limit: null });

const DiscountsAdmin = () => {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/admin/discounts").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const up = (k, v) => setEditing((e) => ({ ...e, [k]: v }));

  const save = async () => {
    try {
      if (editing.id) await api.put(`/admin/discounts/${editing.id}`, editing);
      else await api.post("/admin/discounts", editing);
      toast.success("Saved"); setEditing(null); load();
    } catch (e) { toast.error(typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Failed"); }
  };
  const del = async (id) => { if (!window.confirm("Delete code?")) return; await api.delete(`/admin/discounts/${id}`); load(); };

  if (editing) return (
    <div className="max-w-lg">
      <PageHead title={editing.id ? "Edit Code" : "New Code"}>
        <Btn variant="ghost" onClick={() => setEditing(null)}>Cancel</Btn>
        <Btn onClick={save} testid="admin-save">Save</Btn>
      </PageHead>
      <Card>
        <Field label="Code" value={editing.code} onChange={(v) => up("code", v.toUpperCase())} placeholder="WELCOME10" testid="discount-code-field" />
        <Select label="Type" value={editing.type} onChange={(v) => up("type", v)} options={[{ value: "percent", label: "Percentage off" }, { value: "fixed", label: "Fixed amount off (£)" }]} />
        <Field label={editing.type === "percent" ? "Percent (%)" : "Amount (£)"} type="number" value={editing.value} onChange={(v) => up("value", v)} testid="discount-value-field" />
        <Field label="Minimum spend (£, optional)" type="number" value={editing.min_spend} onChange={(v) => up("min_spend", v)} />
        <Field label="Usage limit (optional)" type="number" value={editing.usage_limit} onChange={(v) => up("usage_limit", v)} />
        <Toggle label="Active" value={editing.active} onChange={(v) => up("active", v)} />
        <Toggle label="Early access only" value={editing.early_access} onChange={(v) => up("early_access", v)} />
      </Card>
    </div>
  );

  return (
    <div>
      <PageHead title="Discount Codes" sub={`${items.length} codes`}>
        <Btn onClick={() => setEditing(empty())} testid="admin-new-discount">+ New Code</Btn>
      </PageHead>
      <div className="bg-cream border border-espresso/10">
        {items.length === 0 && <p className="p-8 text-espresso/40 text-sm">No codes yet.</p>}
        {items.map((d) => (
          <div key={d.id} data-testid={`discount-row-${d.code}`} className="flex items-center gap-4 px-5 py-3 border-b border-espresso/5">
            <div className="flex-1">
              <p className="font-serif text-lg">{d.code} <span className="text-xs text-espresso/40">{d.type === "percent" ? `${d.value}% off` : `£${d.value} off`}</span></p>
              <p className="text-xs text-espresso/50">{d.active ? "active" : "inactive"}{d.early_access ? " · early access" : ""} · used {d.used_count || 0}{d.usage_limit ? `/${d.usage_limit}` : ""}</p>
            </div>
            <Btn variant="ghost" onClick={() => setEditing(d)} testid={`discount-edit-${d.code}`}>Edit</Btn>
            <button onClick={() => del(d.id)} data-testid={`discount-delete-${d.code}`} className="text-wine text-xs tracking-widest uppercase">Delete</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DiscountsAdmin;
